<div
  class="fixed bottom-0 left-0 right-0 top-0 z-50 flex h-full items-center justify-center overflow-hidden bg-neutral-50"
>
  <div class="relative flex h-20 w-full items-center justify-center">
    <p
      [class]="
        'duration-250 absolute px-10 text-center font-medium transition-all ease-in-out ' +
        (textSizeClass() || 'text-xl')
      "
      [ngClass]="{
        'opacity-0 -translate-y-5': isFadingOut,
        'opacity-0 translate-y-5': isFadingIn,
        'opacity-100 translate-y-0': !isFadingOut && !isFadingIn,
      }"
    >
      {{ messages[currentIndex] | translate }}
    </p>
  </div>
</div>
